import * as React from 'react';
import { forwardRef } from 'react';
import { TypographyWrapper } from '@components/atoms/typography/styles';
import type { TypographyProps } from '@components/atoms/typography/types';
import { styled } from '@mui/material/styles';

const TypographyComponent = forwardRef<
    HTMLSpanElement,
    TypographyProps & Omit<React.HTMLAttributes<HTMLSpanElement>, 'color'>
>((props, ref) => {
    const {
        children,
        className,
        tag = 'span',
        color = 'text-main',
        variant,
        style,
        ...rest
    } = props;

    return (
        <TypographyWrapper
            translate='no'
            ref={ref}
            as={tag}
            $variant={variant}
            className={className}
            style={style}
            $color={color}
            {...rest}
        >
            {children}
        </TypographyWrapper>
    );
});

export const Typography = styled(TypographyComponent)({});
